import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { Terminal } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@ouropix/ui';
import { LogViewer } from '@/components/admin-ops/LogViewer';
import { LogFilters, type LogFiltersState } from '@/components/admin-ops/LogFilters';

export const Route = createFileRoute('/_admin/logs')({
  component: LogsPage,
});

const DEFAULT_FILTERS: LogFiltersState = {
  level: 'all',
  service: '',
  search: '',
  limit: 100,
};

function LogsPage() {
  const [filters, setFilters] = useState<LogFiltersState>(DEFAULT_FILTERS);
  const [autoRefresh, setAutoRefresh] = useState(false);

  const updateFilters = (partial: Partial<LogFiltersState>) => {
    setFilters((prev) => ({ ...prev, ...partial }));
  };

  const clearFilters = () => setFilters(DEFAULT_FILTERS);

  const handleTraceFilter = (traceId: string) => {
    updateFilters({ search: traceId });
  };

  return (
    <div className="space-y-6 p-4 md:p-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <Terminal className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Logs do Sistema</h1>
          <p className="text-sm text-muted-foreground">Visualize logs estruturados dos microservicos em tempo real</p>
        </div>
      </div>

      {/* Filters */}
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Filtros</CardTitle>
        </CardHeader>
        <CardContent>
          <LogFilters
            filters={filters}
            autoRefresh={autoRefresh}
            onFiltersChange={updateFilters}
            onClear={clearFilters}
            onAutoRefreshToggle={() => setAutoRefresh((prev) => !prev)}
          />
        </CardContent>
      </Card>

      {/* Log Viewer with Stats */}
      <LogViewer filters={filters} autoRefresh={autoRefresh} onTraceFilter={handleTraceFilter} />
    </div>
  );
}
